var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-submit" }, [
    _c("div", { staticClass: "form-submit--wrap" }, [
      _c(
        "button",
        {
          ref: "submit",
          staticClass: "form-submit--btn btn btn__medium btn__primary",
          class: _vm.buttonClasses,
          attrs: { type: "submit", disabled: _vm.isPending ? true : null },
          on: {
            click: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
              _vm.onSubmit($event)
            }
          }
        },
        [
          _c(
            "transition",
            { attrs: { name: "trs-simple-fade" } },
            [
              _vm.isPending
                ? _c("cmp-wave-loader", {
                    staticClass: "form-submit--wave-loader"
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "form-submit--btn-content btn--wrap" }, [
            _c("span", {
              staticClass: "btn--text",
              domProps: { textContent: _vm._s(_vm.label) }
            })
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.generalErrors.length
      ? _c(
          "div",
          { staticClass: "form-submit--general-errors" },
          _vm._l(_vm.generalErrors, function(generalError, generalErrorIdx) {
            return _c("span", {
              staticClass: "general-error form-submit--general-error",
              domProps: { textContent: _vm._s(generalError) }
            })
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a9de6b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a9de6b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/form/form-submit/index.vue
// module id = 344
// module chunks = 5